import React from 'react';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';

const TimeGauge = ({ measurementData }) => (
  <div>
    <div className="text-xl font-semibold">
      {dayjs(measurementData?.date_value).format('HH:mm')}
    </div>
  </div>
);

TimeGauge.propTypes = {
  measurementData: PropTypes.object,
};

export default TimeGauge;
